import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollRef } from "../../state/scrollState/scrollSignals";
import { es } from "../../state/useEphemeralStore";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      es().setScrollTop(pathname, scrollRef.current?.scrollTop ?? 0);
    }, 500);
    scrollRef.current?.scrollTo({
      top: es().pageStates[pathname]?.scrollTop ?? 0,
      left: 0,
      behavior: "instant",
    });
    return () => {
      clearInterval(interval);
    };
  }, [pathname]);

  return null;
};
